import intellegenceService from "../shared/services/intellegenceService";
import getDates from "../shared/services/date.service";
import { setLogout } from "./authActions";

const REQUEST_MAP_FUELING_POSITIONS = "REQUEST_MAP_FUELING_POSITIONS";
const RESPONSE_MAP_FUELING_POSITIONS = "RESPONSE_MAP_FUELING_POSITIONS";
const REQUEST_MAP_FUELING_POSITIONS_FAILURE = "REQUEST_MAP_FUELING_POSITIONS_FAILURE";
const CLEAR_MAP_FUELING_POSITIONS = "CLEAR_MAP_FUELING_POSITIONS";

const requestMapFuelingPositionsAction = () => {
  return {
    type: REQUEST_MAP_FUELING_POSITIONS,
  };
};

const responseMapFuelingPositionsAction = (data) => {
  return {
    type: RESPONSE_MAP_FUELING_POSITIONS,
    payload: data,
  };
};

const requestMapFuelingPositionsFailureAction = (errors) => {
  return {
    type: REQUEST_MAP_FUELING_POSITIONS_FAILURE,
    errors,
  };
};

const getMapFuelingPositions = (options) => {
  const startDate = getDates.fixISOStringDateToPost(options.startDate);
  const endDate = getDates.fixISOStringDateToPost(options.endDate);

  return (dispatch) => {
    dispatch(requestMapFuelingPositionsAction());

    intellegenceService
      .getFuelings(options.carId, {
        startDate,
        endDate,
        timeZone: (new Date().getTimezoneOffset() / 60) * -1,
      })
      .then((result) => {
        dispatch(responseMapFuelingPositionsAction(result.data));
      })
      .catch((error) => {
        dispatch(requestMapFuelingPositionsFailureAction(error.response));

        if (error.response && error.response.status === 401) {
          dispatch(setLogout());
        }
      });
  };
};

const clearMapFuelingPositionsAction = () => {
  return {
    type: CLEAR_MAP_FUELING_POSITIONS,
  };
};

export {
  REQUEST_MAP_FUELING_POSITIONS,
  RESPONSE_MAP_FUELING_POSITIONS,
  REQUEST_MAP_FUELING_POSITIONS_FAILURE,
  CLEAR_MAP_FUELING_POSITIONS,
  requestMapFuelingPositionsAction,
  responseMapFuelingPositionsAction,
  requestMapFuelingPositionsFailureAction,
  getMapFuelingPositions,
  clearMapFuelingPositionsAction,
};
